import { MaintenanceObjectivePartsData } from "../types/MaintenanceObjectiveParts.type";
import ActionLinkButton from "@/common/components/ActionLinkButton";

export class MaintenanceObjectivePartsTransformer {

  static tableTransformer() {
    return (objectiveParts: MaintenanceObjectivePartsData[]) => {
      return objectiveParts.map((objectiveParts) => {
        return {
          ...objectiveParts,
          systems_display_name: objectiveParts.system_parts.map((system) => system.system.display_name).join(', '),
          actions: (
            <ActionLinkButton
              linkTo={objectiveParts.id}
              operationKlassToCheckPermission="Admin::Maintenance::ObjectiveParts::Show"
              dataTestid="show_button"
            />
          ),
        }
      });
    }
  }

}
